module.exports = __webpack_public_path__ + "img/exclusive.5a5dd29a.svg";